module.exports = __webpack_public_path__ + "960ddf76069aa3e157232464ea19c392.png";